class Base {
  constructor() {
    this.calcOrientation();
    this.initListener();
  }
  onChange(handler) {
    this.onChange = handler;
  }
  fireChange() {
    if (typeof this.onChange === 'function') {
      this.onChange(this.orientation);
    }
  }
}

// 使用屏幕旋转事件检测
class Orientation extends Base {
  calcOrientation() {
    this.orientation = window.orientation === 0 || window.orientation === 180 ? 'portrait' : 'landscape';
  }
  initListener() {
    window.addEventListener('orientationchange', () => {
      this.calcOrientation();
      this.fireChange();
    });
  }
}

// 使用媒体查询检测
class MediaOrientation extends Base {
  calcOrientation() {
    this.orientation = this.getMedia().matches ? 'portrait' : 'landscape';
  }
  getMedia() {
    if (!this.media) {
      this.media = window.matchMedia('(orientation: portrait)');
    }
    return this.media;
  }
  initListener() {
    this.getMedia().addListener(() => {
      this.calcOrientation();
      this.fireChange();
    });
  }
}

// 使用 resize 事件检测
class ResizeOrientation extends Base {
  calcOrientation() {
    this.orientation = document.documentElement.clientWidth < document.documentElement.clientHeight ? 'portrait' : 'landscape';
  }
  initListener() {
    window.addEventListener('resize', () => {
      const oldOrientation = this.orientation;
      this.calcOrientation();
      if (oldOrientation !== this.orientation) {
        this.fireChange();
      }
    }, 50);
  }
}

export function create(detector) {
  if (('orientation' in window && !detector) || (detector && detector === 'orientation')) {
    console.info('[Orientation.create]orientation mode');
    return new Orientation();
  }
  if ((window.matchMedia && !detector) || (detector && detector === 'media')) {
    console.info('[Orientation.create]matchMedia mode');
    return new MediaOrientation();
  }
  console.info('[Orientation.create]resize mode');
  return new ResizeOrientation();
}
